import React, {useState} from 'react';
import {Table, Popover, Whisper, Modal} from 'rsuite';
import 'rsuite/dist/styles/rsuite-default.css'
import {makeStyles} from "@material-ui/core/styles";
import EncodeSansBold from "../../assets/fonts/Encode_Sans/EncodeSans-Bold.ttf";


const {Column, HeaderCell, Cell} = Table;

const useStyle = makeStyles((theme) => ({
    formTitle: {
        fontFamily: "Poppins",
        fontWeight:'500',
        fontSize: "20px",
        color: "#bb0d66",
        textAlign: "center"
    },
}))


const NameCell = ({rowData, dataKey, ...props}) => {

    if(dataKey === "valor_cuota_promedio"){
        return (
            <Cell {...props}>
                {"$ " + rowData[dataKey].toLocaleString()}
            </Cell>
        );
    }
    if(dataKey === "conversion_rate"){
        return (
            <Cell {...props}>
                {rowData[dataKey].toLocaleString() + "%"}
            </Cell>
        );
    }

    return (
        <Cell {...props}>
            {rowData[dataKey].toLocaleString()}
        </Cell>
    );
};


function AdvisersControlTable(props) {
    let data = props.advisersData;
    const classes = useStyle();

    return (
        <React.Fragment>
            <div style={{display: 'flex', flexDirection: 'column',}}>
                <div style={{display: 'flex', flexDirection: 'row', margin: '8px 0 16px 0', justifyContent: "center"}}>
                    <h3 className={classes.formTitle}>Información de Asesores</h3>
                </div>


                < Table
                    height={480}
                    width={800}
                    data={data}
                >
                    <Column width={230} fixed sortable>
                        <HeaderCell>Nombre</HeaderCell>
                        <NameCell dataKey="nombre"/>
                    </Column>
                    <Column width={130} align={"center"}>
                        <HeaderCell>N. de cotizaciones</HeaderCell>
                        <NameCell dataKey="total_cotizaciones"/>
                    </Column>
                    <Column width={110} align={"center"}>
                        <HeaderCell>N. de emisiones</HeaderCell>
                        <NameCell dataKey="total_emisiones"/>
                    </Column>
                    <Column width={160} align={"center"}>
                        <HeaderCell>Porcentaje de conversión</HeaderCell>
                        <NameCell dataKey="conversion_rate"/>
                    </Column>
                    <Column width={160} align={"center"}>
                        <HeaderCell>Valor cuota promedio</HeaderCell>
                        <NameCell dataKey="valor_cuota_promedio"/>
                    </Column>

                </Table>

            </div>
        </React.Fragment>

    );
}

export default AdvisersControlTable;